var exports = {
  "k": "xf1bb6bc5--464ca6--container",
};

module.exports = exports;
